import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { apisiseci } from "../../../../api";
import { AxiosError } from "axios";
import { AttendanceLocalDepartmentSchedule } from "../../../../../@types/attendance-local-department-schedule";

export type AttendanceLocalDepartmentScheduleCreateData = Pick<
    AttendanceLocalDepartmentSchedule,
    | "setor"
    | "dia_semana"
    | "hora_inicio"
    | "hora_fim"
    | "intervalo_hora_inicio"
    | "intervalo_hora_fim"
    | "ativo"
    | "motivo_inativo"
>;

export function useAttendanceLocalDepartmentScheduleCreate() {
    const queryClient = useQueryClient();
    const token = localStorage.getItem("gov_access_token_sso");

    const mutation = useMutation({
        mutationKey: ["attendance-local", "department", "schedule", "create"],
        mutationFn: async (data: AttendanceLocalDepartmentScheduleCreateData) => {
            const response = await apisiseci.post<AttendanceLocalDepartmentSchedule>(
                '/cms/horario_atendimento/', data,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            return response.data;
        },
        onSuccess: async () => {
            toast.success("Horário de funcionamento criado com sucesso!");

            await queryClient.invalidateQueries({
                queryKey: ["attendance-local", "department", "schedule", "list"],
            });
        },
        onError: (error: AxiosError<{ detail: string }>) => {
            toast.error(
                error?.response?.data?.detail || "Algo deu errado, tente novamente!"
            );
            console.log(error);
        },
    });

    return mutation;
}
